import { render, staticRenderFns } from "./Cog.vue?vue&type=template&id=0e61113c&scoped=true&"
var script = {}
import style0 from "./Cog.vue?vue&type=style&index=0&id=0e61113c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e61113c",
  null
  
)

export default component.exports